import React from 'react'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import RetractablePanel from 'components/RetractablePanel'
import Input from 'components/Input'
import Button from 'components/Button'

import { statusChanged } from 'components/RequestStatus/actions'
import { claimChanged } from 'scenes/VehicleDetail/actions'

import { CLAIM_UPDATE } from 'constants'

import './styles.scss'

export class Cost extends BaseComponent {


  constructor(props) {
    super(props)
    this.state = {
      editting: false,
      paid: props.claim.paid || 0,
      expenses: props.claim.expenses || 0,
      salvage: props.claim.salvage || 0,
      deductible: props.claim.deductible || 0,
      salvage_reserve: props.claim.salvage_reserve || 0,
      claim_reserve: props.claim.claim_reserve || 0,
      claim_cost: props.claim.claim_cost || 0,
      paid_zero: true,
      expenses_zero: true,
      salvage_zero: true,
      deductible_zero: true,
      salvage_reserve_zero: true,
      claim_reserve_zero: true  
    }

    this._bind( 
                '_onEdit', '_renderEditForm', '_renderData', '_handleSubmit', 
                '_handleChange', '_onCancelEdit',
                '_renderCost', '_renderCostForm')
  }

  componentDidMount() {
    this._computeTotal()
  }

  _computeTotal(){
    /* total = paid + expenses + salvage + deductible + claim_cost */
  }

  _onEdit(evt) {
    evt.preventDefault()
    this.panel.open()
    this.setState({ editting: true })
  }

  _onCancelEdit(evt) {
    evt.preventDefault()
    this.panel.open()
    this.setState({ editting: false })
  }

  _renderHeaderActions() {
    return !this.state.editting ? (
      <div>
        <button onClick={this._onEdit}>
          <i className="material-icons">edit</i>
        </button>
      </div>
    ) : (
      <div>
        <button onClick={this._onCancelEdit}>
          <i className="material-icons">close</i>
        </button>
      </div>
    )
  }

  _handleSubmit(e) {
    e.preventDefault()
    const formData = new FormData()

    formData.append('deductible', this.state.deductible)
    formData.append('paid', this.state.paid) 
    formData.append('expenses', this.state.expenses)
    formData.append('salvage', this.state.salvage) 
    formData.append('salvage_reserve', this.state.salvage_reserve)
    formData.append('claim_reserve', this.state.claim_reserve)

    this.props.updateRequestStatus('progress', 'Modificando datos del siniestro...')
    request(CLAIM_UPDATE(this.props.claim.id), {
      method: 'PUT',
      isUpload: true,
      body: formData
    }).then((res) => {
      this.props.updateRequestStatus('ok', 'Datos modificados')
      this.setState({
        paid: this.state.paid,
        expenses: this.state.expenses,
        salvage: this.state.salvage,
        deductible: this.state.deductible,
        salvage_reserve: this.state.salvage_reserve,
        claim_reserve: this.state.claim_reserve,
        claim_cost: res.claim_cost
      })
    }).catch((err) => {this.props.updateRequestStatus('error', 'No pudimos modificar los datos')})

    this.setState({
      editting: false
    })
  }

  _handleChange(e) {
    var value = e.target.value
    if (value === ''){
      value = "0"
    }else if (value.length === 5 && value.substr(0, 4) === '0.00' && this.state[`${e.target.name}_zero`]){
      value = value.charAt(4)
      this.setState({ [`${e.target.name}_zero`]: false })
    }else if (value.length > 1 && value.charAt(0) === '0' && value.charAt(1) !== '.'){
      value = value.substr(1,value.length)
    }
    this.setState({ [e.target.name]: value })
    //var cost = Number(this.state.paid) + Number(this.state.salvage) + Number(this.state.deductible) + Number(this.state.claim_reserve) + Number(this.state.expenses) - Number(this.state.salvage_reserve)    
  }

  _renderEditForm() {
    return(
      <form onSubmit={this._handleSubmit} className="CostData__form">
        {this._renderCostForm()}
        <div className="controls d-flex justify-content-end">
          <Button buttonType="primary"
                  size="small">Actualizar siniestro</Button>
        </div>
      </form>
    )
  }

  _renderCostForm() {
    return (
      <div className="CostDataForm">
        <div className="form-field">
          <label>Deducible:</label>
          <Input  onChange={this._handleChange}
                name="deductible"
                value={this.state.deductible}
                placeholder="Deducible"/>
        </div>
        <div className="form-field">
          <label>Siniestro pagado:</label>
          <Input  onChange={this._handleChange}
                name="paid"
                value={this.state.paid}
                placeholder="Siniestro pagado"/>
        </div>
        <div className="form-field">
          <label>Gastos:</label>
          <Input  onChange={this._handleChange}
                name="expenses"
                value={this.state.expenses}
                placeholder="Gastos"/>
        </div>
        <div className="form-field">
          <label>Salvamentos efectuados:</label>
          <Input  onChange={this._handleChange}
                name="salvage"
                value={this.state.salvage}
                placeholder="Salvamentos efectuados"/>
        </div>
        <div className="form-field">
          <label>Reserva salvamentos:</label>
          <Input  onChange={this._handleChange}
                name="salvage_reserve"
                value={this.state.salvage_reserve}
                placeholder="Reserva salvamentos"/>
        </div>
        <div className="form-field">
          <label>Reserva siniestros:</label>
          <Input  onChange={this._handleChange}
                name="claim_reserve"
                value={this.state.claim_reserve}
                placeholder="Reserva siniestros"/>
        </div>
        <br></br>
        <div className="form-field">
          <label>Costo total:</label>
          <p><strong><span>{this.state.claim_cost}</span></strong></p>
        </div>
      </div>
    )
  }

  _renderData() {
    return(
      <div className="CostData__data">
        {this._renderCost()}
      </div>
    )
  }

  _renderCost() {
    let cost = null

    if (Math.abs(this.state.claim_cost) !== Number(this.state.deductible) ) {
      cost = (
        <div className="data-field">
          <label>Costo total:</label>
          <p><span>{this.state.claim_cost}</span></p>
        </div>
        )
    }

    return (
      <div>
        <div className="data-field">
          <label>Deducible:</label>
          <p><span>{this.state.deductible}</span></p>
        </div>
        { cost }
      </div>
    )
  }

  render() {
    return(
      <div id="CostData" className="CostData">
        <RetractablePanel
          ref={(panel) => this.panel = panel}
          name="Costos del siniestro"
          actionButtons={this._renderHeaderActions()}
          isToggle={true}
        >
          {this.state.editting ? this._renderEditForm() : this._renderData() }
        </RetractablePanel>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    claim: state.vehicleDetail.get('claim')
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message)),
    claimChanged: (vehicle) => dispatch(claimChanged(vehicle))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Cost)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/ClaimData/Cost/index.js